import React from "react";
import FinanceComponent from "./Finance";
import { connect } from "react-redux";

const Finance = (props) => {

  return (
    <div>
      <FinanceComponent
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Finance);
